const _shop_id = (window as any).shopConfig ? (window as any)?.shopConfig.shopId : (window as any).shopId

function getBaseUrl(): {CR: string, BASE_URL: string, AWS_URL: string} {
    // 生产环境 接口域名
    const prodUrl = "https://api.myjackery.com"
    // uat环境 接口域名
    const uatUrl = "https://api-uat.myjackery.com"
    // 开发环境 接口域名
    const devUrl = "https://demo-api.myjackery.com"

    switch (_shop_id) {
      case "9709262": 
        return {
            CR: "US",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "60738666677": 
        return {
            CR: "CA",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "10015375438": 
        return {
            CR: "JP",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "56981160124": 
        return {
            CR: "GB",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "57272172741": 
        return {
            CR: "DE", 
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "60455780502": 
        return {
            CR: "KR",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "68984701213": 
        return {
            CR: "AU",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "69511053598": 
        return {
            CR: "FR",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "69224431898": 
        return {
            CR: "IT",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "69013700929": 
        return {
            CR: "ES",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "73356443969": 
        return {
            CR: "EU",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "74688758050": 
        return {
            CR: "HK",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "74914496810": 
        return {
            CR: "MO",
            BASE_URL: prodUrl,
            AWS_URL:  "https://aws-gateway.hijackery.cn" 
        }
      case "79611232554": 
        return {
            CR: "US",
            BASE_URL: uatUrl,
            AWS_URL:  "https://aws-gateway-uat.hijackery.cn" 
        }
      default: 
        return {
            CR: "US",
            BASE_URL: devUrl,
            AWS_URL: "https://10.1.74.145:8093"

        }
    }
}

const CR: string = getBaseUrl().CR
const BASE_URL: string = getBaseUrl().BASE_URL
const lang: string = document.querySelector("html").getAttribute("lang") || ""

const initial = {
  method: 'GET',
  // cache: 'no-cache',
  // credentials: 'include',
  // responseType: 'JSON',
  // mode: 'cors',
  headers: {
    cr: CR, 
    lang
  }
};

function request(url_: string, config_) {
    let url = url_
    let config = config_ ? {...initial, ...config_} : {...initial}

    if (typeof url !== 'string') throw new TypeError('url must be required and of string type');
    const { params, body, headers, token, method } = config;
    if(body && body instanceof FormData && method == 'POST') { // formdata提交
      delete config.headers['Content-Type']
      // config.headers['Content-Type'] = 'multipart/form-data';
      config.body = body
    } else {
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body)
    }

    if(params && method === 'GET') {
        let params_search = ''
        if (params.constructor === Object) {
          const values = Object.values(params);
          const keys = Object.keys(params);
          const arr = [];
          for (let i = 0; i < values.length; i++) {
            arr.push(`${keys[i]}=${values[i]}`)
          }
          params_search = arr.join("&")
        }
        url += `${url.includes('?') ? '&' : '?'}${params_search}`
    }

    token && (headers.jackeryToken = token)

    console.log(config)
    return new Promise((resolve, reject) => {
        fetch(`${BASE_URL}${url}`, config)
        .then(res => {
            if(res.status >= 200 && res.status < 400) {
                return res.json()
            }
            reject({code: 'STATUS ERROR', status: res.status, statusText: res.statusText})
        })
        .then(res => {
            if((res as any).code) {
                switch ((res as any).code) {
                    case 200:
                        resolve(res.data)
                        return;
                    case 10000:
                        resolve(res.data)
                        return;
                    default:
                        reject(res)
                }
            }
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const post = (url, config) => request(url, {method: 'POST', ...config})
export const get = (url, config) => request(url, {method: 'GET', ...config})